"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _TranscriptionStatusT;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranscriptEventConverter = void 0;

var SignalingProtocol_1 = require("../signalingprotocol/SignalingProtocol");

var Transcript_1 = require("./Transcript");

var TranscriptionStatus_1 = require("./TranscriptionStatus");

var TranscriptionStatusType_1 = require("./TranscriptionStatusType");

var TranscriptItemType_1 = require("./TranscriptItemType");

var TranscriptionStatusTypes = (_TranscriptionStatusT = {}, _defineProperty(_TranscriptionStatusT, SignalingProtocol_1.SdkTranscriptionStatus.Type.STARTED, TranscriptionStatusType_1.default.STARTED), _defineProperty(_TranscriptionStatusT, SignalingProtocol_1.SdkTranscriptionStatus.Type.INTERRUPTED, TranscriptionStatusType_1.default.INTERRUPTED), _defineProperty(_TranscriptionStatusT, SignalingProtocol_1.SdkTranscriptionStatus.Type.RESUMED, TranscriptionStatusType_1.default.RESUMED), _defineProperty(_TranscriptionStatusT, SignalingProtocol_1.SdkTranscriptionStatus.Type.STOPPED, TranscriptionStatusType_1.default.STOPPED), _defineProperty(_TranscriptionStatusT, SignalingProtocol_1.SdkTranscriptionStatus.Type.FAILED, TranscriptionStatusType_1.default.FAILED), _TranscriptionStatusT);

var TranscriptEventConverter = /*#__PURE__*/function () {
  function TranscriptEventConverter() {
    _classCallCheck(this, TranscriptEventConverter);
  }

  _createClass(TranscriptEventConverter, null, [{
    key: "from",
    value:
    /**
     * Decodes a list of TranscriptEvent from a data message.
     * @param dataMessage Data message to decode from
     * @returns List of TranscriptEvent
     * @throws {Error} If the data message payload cannot be decoded
     */
    function from(dataMessage) {
      var frame;

      try {
        frame = SignalingProtocol_1.SdkTranscriptFrame.decode(dataMessage.data);
      } catch (e) {
        throw new Error('Cannot decode transcript data message: ' + e);
      }

      var transcriptEvents = [];

      var _iterator = _createForOfIteratorHelper(frame.events),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var sdkTranscriptEvent = _step.value;

          if (sdkTranscriptEvent.status) {
            var transcriptionStatusType = TranscriptionStatusTypes[sdkTranscriptEvent.status.type];

            if (!transcriptionStatusType) {
              continue;
            }

            var transcriptionStatus = new TranscriptionStatus_1.default();
            transcriptionStatus.type = transcriptionStatusType;
            transcriptionStatus.eventTimeMs = sdkTranscriptEvent.status.eventTime;
            transcriptionStatus.transcriptionRegion = sdkTranscriptEvent.status.transcriptionRegion;
            transcriptionStatus.transcriptionConfiguration = sdkTranscriptEvent.status.transcriptionConfiguration;

            if (sdkTranscriptEvent.status.message) {
              transcriptionStatus.message = sdkTranscriptEvent.status.message;
            }

            transcriptEvents.push(transcriptionStatus);
          } else if (sdkTranscriptEvent.transcript) {
            var transcript = new Transcript_1.default();
            transcript.results = [];

            var _iterator2 = _createForOfIteratorHelper(sdkTranscriptEvent.transcript.results),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var result = _step2.value;
                var transcriptResult = {
                  channelId: result.channelId,
                  isPartial: result.isPartial,
                  resultId: result.resultId,
                  startTimeMs: result.startTime,
                  endTimeMs: result.endTime,
                  alternatives: []
                };

                var _iterator3 = _createForOfIteratorHelper(result.alternatives),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var alternative = _step3.value;
                    var transcriptAlternative = {
                      items: [],
                      transcript: alternative.transcript
                    };

                    var _iterator4 = _createForOfIteratorHelper(alternative.items),
                        _step4;

                    try {
                      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                        var item = _step4.value;
                        var transcriptItem = {
                          content: item.content,
                          attendee: {
                            attendeeId: item.speakerAttendeeId,
                            externalUserId: item.speakerExternalUserId
                          },
                          startTimeMs: item.startTime,
                          endTimeMs: item.endTime,
                          type: null
                        };

                        if (item.vocabularyFilterMatch) {
                          transcriptItem.vocabularyFilterMatch = item.vocabularyFilterMatch;
                        }

                        if (item.hasOwnProperty('stable')) {
                          transcriptItem.stable = item.stable;
                        }

                        if (item.hasOwnProperty('confidence')) {
                          transcriptItem.confidence = item.confidence;
                        }

                        switch (item.type) {
                          case SignalingProtocol_1.SdkTranscriptItem.Type.PRONUNCIATION:
                            transcriptItem.type = TranscriptItemType_1.default.PRONUNCIATION;
                            break;

                          case SignalingProtocol_1.SdkTranscriptItem.Type.PUNCTUATION:
                            transcriptItem.type = TranscriptItemType_1.default.PUNCTUATION;
                            break;
                        }

                        transcriptAlternative.items.push(transcriptItem);
                      }
                    } catch (err) {
                      _iterator4.e(err);
                    } finally {
                      _iterator4.f();
                    }

                    var _iterator5 = _createForOfIteratorHelper(alternative.entities),
                        _step5;

                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        var entity = _step5.value;

                        if (!transcriptAlternative.entities) {
                          transcriptAlternative.entities = [];
                        }

                        var transcriptEntity = {
                          category: entity.category,
                          confidence: entity.confidence,
                          content: entity.content,
                          startTimeMs: entity.startTime,
                          endTimeMs: entity.endTime
                        };

                        if (entity.type) {
                          transcriptEntity.type = entity.type;
                        }

                        transcriptAlternative.entities.push(transcriptEntity);
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }

                    transcriptResult.alternatives.push(transcriptAlternative);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                transcript.results.push(transcriptResult);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            transcriptEvents.push(transcript);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return transcriptEvents;
    }
  }]);

  return TranscriptEventConverter;
}();

exports.TranscriptEventConverter = TranscriptEventConverter;